module.exports = __webpack_public_path__ + "img/zhuangfa.500e43db.svg";